export { default } from "./CitiesFAQs";
